module.exports = __webpack_public_path__ + "img/2.9230a4b9.jpg";